import React, { useState } from "react";
import Viewimage from "../../../../api/Viewimage";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Stack, Tab } from "@mui/material";
const FundingAndFinancialDetails = ({ details, detail }) => {
  const [open, setOpen] = useState(false);
  const [viewImage, setViewImage] = useState("");
  const handleClickOpen = (value) => {
    setViewImage(value);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [value, setValue] = React.useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <main>
      <section>
       
          <div className="">
            <div className="row">
              <div className="col-lg-4">
                <p className="mt-4">
                  <b>Desired Funding Amount (₹) :</b>
                </p>
                <p>{details.fundAmount}</p>
              </div>
              <div className="col-lg-4">
                <p className="mt-4">
                  <b>Annual Revenue (₹) :</b>
                </p>
                <p>{details.annualRevenue}</p>
              </div>
            </div>
          </div>
          {details.fundHistory && (
            <div className="col-lg-12 col-12 my-3">
              <div className="div_header">
                <h6>Previous Fundraising History</h6>
              </div>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="caption table">
                  <TableHead className="tablehead">
                    <TableRow>
                      <TableCell>No</TableCell>
                      <TableCell>Fund Raised (₹)</TableCell>
                      <TableCell>Organization Name</TableCell>
                      <TableCell>Instrument Type</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {details.fundHistory.map((list, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{list.fundRaised}</TableCell>
                        <TableCell>{list.organisationName}</TableCell>
                        <TableCell>{list.instrumentType}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
      </section>

      <Viewimage viewImage={viewImage} open={open} handleClose={handleClose} />
    </main>
  );
};

export default FundingAndFinancialDetails;
